import { AppBar, Box, Menu, MenuItem, Toolbar, Typography, IconButton } from '@mui/material';
import React from 'react'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { persistor } from '../../store/store';
import LeftNav from '../LeftNav';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../actions/userAction';

const NavBar = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [drawerOpen, setDrawerOpen] = React.useState(false); // Drawer state for mobile
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const { user ,client } = useSelector((state) => state.user.userInfo) || {};
        const  user1  = useSelector((state) => state.user) || {};

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = () => {
        dispatch(logoutUser())
        persistor.purge();
        navigate('/login')
    }

    return (
        <>
            <AppBar component="nav" elevation={0} sx={{
                bgcolor: '#0B3C5D',
                color: '#fff',
                minHeight: { xs: 50, md: 64 },
                boxShadow: '0 6px 24px 0 rgba(11, 60, 93, 0.18)', // شادو قوي وواضح
                borderBottom: '2px solid #FFD700',
                justifyContent: 'center',
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                zIndex: (theme) => theme.zIndex.appBar, // عادة 1100
            }}>
                <Toolbar sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: { xs: 50, md: 64 },
                    px: { xs: 1, md: 6 },
                    py: { xs: 0.5, md: 0 },
                    gap: 2,
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: { xs: 'unset', md: '0 0 auto' } }}>
                        <IconButton
                            sx={{ display: { xs: 'inline-flex', md: 'none' }, mr: 1, color: '#fff', transition: 'color 0.2s', '&:hover': { color: '#D9B310' } }}
                            size="large"
                            onClick={() => setDrawerOpen(true)}
                        >
                            <MenuIcon fontSize="inherit" />
                        </IconButton>
                        <Typography sx={{ display: { xs: 'none', md: 'block' }, fontWeight: 900, fontSize: 26, letterSpacing: 2, ml: 1, color: '#fff' }}>
                            VMS <Box component="span" sx={{ color: '#D9B310', fontWeight: 900 }}>Pro</Box>
                        </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, md: 2 } }}>
                        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: { xs: 14, md: 17 }, letterSpacing: 1, display: { xs: 'none', md: 'block' } }}>
                            Howdy,   {client?.name || ''} {client?.company && `(${client?.company})`} {user?.firstName}!
                        </Typography>
                        <AccountCircleIcon
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleClick}
                            sx={{
                                color: '#fff',
                                fontSize: { xs: 26, md: 32 },
                                cursor: 'pointer',
                                transition: 'color 0.2s',
                                '&:hover': { color: '#D9B310' }
                            }}
                        />
                        <Menu
                            id="basic-menu"
                            variant='menu'
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                            PaperProps={{
                                sx: { mt: 1, minWidth: 150, borderRadius: 2, boxShadow: '0 2px 12px 0 rgba(11, 60, 93, 0.10)' }
                            }}
                        >
                            <MenuItem onClick={() => {
                                navigate('/updatePassword')
                                handleClose();
                            }} sx={{ fontSize: { xs: 14, md: 16 } }}>Change Password</MenuItem>
                        </Menu>
                        <LogoutIcon onClick={handleLogout} sx={{ color: '#fff', fontSize: { xs: 22, md: 28 }, ml: 1, cursor: 'pointer', '&:hover': { color: '#D9B310' } }} />
                    </Box>
                </Toolbar>
            </AppBar>
            <Box sx={{ height: '100vh', position: 'fixed', top: 64, left: 0, zIndex: (theme) => theme.zIndex.appBar - 1, flexShrink: 0 }}>
                <LeftNav drawerOpen={drawerOpen} onNavClick={() => setDrawerOpen(false)} />
            </Box>
        </>

    )
}

export default NavBar;